module.exports = "<div class=\"ot-type-list\">\n  <div ng-repeat=\"type in vm.typeList | type:params.alcoholPolicy:params.dietaryRestrictions\">\n    <div ng-class=\"type.iconClass\"></div>\n    <span>{{type.label | translate}}</span>\n  </div>\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/directives/content/typeList.html
 ** module id = 277
 ** module chunks = 1
 **/